module.exports = __webpack_public_path__ + "static/media/arrow_up_icon.84e854bd.svg";